import { render, staticRenderFns } from "./TwApprovalList.vue?vue&type=template&id=83a6362c&scoped=true&"
import script from "./TwApprovalList.vue?vue&type=script&lang=js&"
export * from "./TwApprovalList.vue?vue&type=script&lang=js&"
import style0 from "./TwApprovalList.vue?vue&type=style&index=0&id=83a6362c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a6362c",
  null
  
)

export default component.exports